import { listReminderLogs, ReminderLog } from '@training24/course/src/reminderLog'

interface ReminderLogState {
  all: ReminderLog[]
  loaded: boolean
  loading: boolean
}

export type { ReminderLog }

export default {
  namespaced: true,

  state: (): ReminderLogState => ({
    all: [],
    loaded: false,
    loading: false,
  }),

  getters: {
    // Neueste zuerst
    getAll: (state: ReminderLogState): ReminderLog[] =>
      [...state.all].sort((a, b) => b.sentAt - a.sentAt),
    isLoaded: (state: ReminderLogState): boolean => state.loaded,
    isLoading: (state: ReminderLogState): boolean => state.loading,
  },

  actions: {
    async LOAD_ALL(context: any, payload: { orgId: string; force?: boolean } | string) {
      const orgId = typeof payload === 'string' ? payload : payload.orgId
      const force = typeof payload === 'string' ? false : !!payload.force
      if (!orgId) return
      if (context.state.loaded && !force) return

      const jwt = context.rootGetters['getJWT']
      context.commit('SET_LOADING', true)
      try {
        const items = await listReminderLogs(orgId, jwt)
        context.commit('SET_ALL', items)
      } finally {
        context.commit('SET_LOADING', false)
      }
    },
  },

  mutations: {
    SET_ALL(state: ReminderLogState, items: ReminderLog[]) {
      state.all = items
      state.loaded = true
    },
    SET_LOADING(state: ReminderLogState, value: boolean) {
      state.loading = value
    },
  },
}
